import { styled } from '@linaria/react';

export const VisibilityGuardWrapper = styled.div<{ isVisible: boolean }>`
	display: flex;
	overflow: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	height: 100%;
	max-height: ${({ isVisible }) => (isVisible ? 'auto' : '0')};
	flex-direction: column;
	flex-grow: 1;

	& > .loader {
		margin: auto;
	}
`;
